import ExceptionHandling from './ExceptionHandling.js'
import { useStore, ActionTypes } from "../store";
import instance from './index';

export default class ProfilerService {
	getItems(keyword, start) {
		//SHOW LOADING
		const store = useStore();
		store.dispatch(ActionTypes.PROGRESS_BAR, true);
		const api = '/api/profilers_list';
		const formData = new FormData();
		formData.append('keyword', keyword);
		formData.append('start', start);
		return instance()(
			{
				method: 'post',
				url: api,
				data: formData,
			}
		).then(res => res.data)
			.catch((e) => ExceptionHandling.HandleErrors(e))
			.finally(() => {
				store.dispatch(ActionTypes.PROGRESS_BAR, false);
			})
	}

	saveItem(postObj, stateObj, currentUserID) {
		//SHOW LOADING
		const store = useStore();
		store.dispatch(ActionTypes.PROGRESS_BAR, true);
		const api = '/api/add_profilers';
		const formData = new FormData();
		formData.append('account_title', stateObj.accountTitle);
		formData.append('email_address', (stateObj.emailAddress) ? stateObj.emailAddress : '');
		formData.append('contact_no', stateObj.contactNo);
		formData.append('national_id', (stateObj.nationalId) ? stateObj.nationalId : '');
		formData.append('address', (stateObj.address) ? stateObj.address : '');
		formData.append('description', (stateObj.description) ? stateObj.description : '');
		formData.append('account_type', postObj.accountType.key);
		formData.append('company', (stateObj.company) ? stateObj.company : '');
		formData.append('default_expiry_alert_duration', (stateObj.defaultExpiryAlertDuration) ? stateObj.defaultExpiryAlertDuration : 0);
		formData.append('status', postObj.status);
		formData.append('created_user', currentUserID);
		//console.log("Account title is ",stateObj.accountTitle);
		//console.log("default expiry is ",postObj.defaultExpiryAlertDuration);
		return instance()(
			{
				method: 'post',
				url: api,
				data: formData,
			}
		).then(res => res.data)
			.catch((e) => ExceptionHandling.HandleErrors(e))
			.finally(() => {
				store.dispatch(ActionTypes.PROGRESS_BAR, false);
			})
	}

	save(postObj) {
				////console.log("save junction caled in js");
				//SHOW LOADING
				const store = useStore();
				store.dispatch(ActionTypes.PROGRESS_BAR, true);
				const api = '/api/save_profilers_bulk';
				const formData = new FormData();
				formData.append('item_list', JSON.stringify(postObj));
				//console.log("POSTOBJECT ",postObj);
				return instance()(
					{
						method: 'post',
						url: api,
						data: formData,
					}
				).then(res => res.data)
					.catch((e) => ExceptionHandling.HandleErrors(e))
					.finally(() => {
						store.dispatch(ActionTypes.PROGRESS_BAR, false);
					})
					
	}

	updateItem(postObj, stateObj) {
		//SHOW LOADING
		const store = useStore();
		store.dispatch(ActionTypes.PROGRESS_BAR, true);
		const api = '/api/edit_profilers';
		const formData = new FormData();
		formData.append('id', postObj.id);
		formData.append('account_title', stateObj.accountTitle);
		formData.append('email_address', postObj.emailAddress);
		formData.append('contact_no', stateObj.contactNo);
		formData.append('national_id', postObj.nationalId);
		formData.append('address', postObj.address);
		formData.append('description', postObj.description);
		formData.append('account_type', postObj.accountType.key);
		formData.append('company', postObj.company);
		
		return instance()(
			{
				method: 'post',
				url: api,
				data: formData,
			}
		).then(res => res.data)
			.catch((e) => ExceptionHandling.HandleErrors(e))
			.finally(() => {
				store.dispatch(ActionTypes.PROGRESS_BAR, false);
			})
	}

	getItem(data) {
		//SHOW LOADING
		const store = useStore();
		store.dispatch(ActionTypes.PROGRESS_BAR, true);
		const api = '/api/get_profilers/' + data.id;
		return instance().get(api)
			.then(res => res.data)
			.catch((e) => ExceptionHandling.HandleErrors(e))
			.finally(() => {
				store.dispatch(ActionTypes.PROGRESS_BAR, false);
			})
	}

	changeStatus(postObj) {
		//SHOW LOADING
		const store = useStore();
		store.dispatch(ActionTypes.PROGRESS_BAR, true);
		const api = '/api/delete_profilers';
		const formData = new FormData();
		formData.append('id', postObj.id);
		formData.append('status', postObj.status);

		return instance()(
			{
				method: 'post',
				url: api,
				data: formData,
			}
		).then(res => res.data)
			.catch((e) => ExceptionHandling.HandleErrors(e))
			.finally(() => {
				store.dispatch(ActionTypes.PROGRESS_BAR, false);
			})
	}
	
	searchProfiler(keyword, accountType) {
		//SHOW LOADING
		const store = useStore();
		store.dispatch(ActionTypes.PROGRESS_BAR, true);
		const api = '/api/search_profilers';
		const formData = new FormData();
		formData.append('keyword', keyword);
		formData.append('account_type', accountType);

		return instance()(
			{
				method: 'post',
				url: api,
				data: formData,
			}
		).then(res => res.data)
			.catch((e) => ExceptionHandling.HandleErrors(e))
			.finally(() => {
				store.dispatch(ActionTypes.PROGRESS_BAR, false);
			})
	}

			exportSampleStock()
			{
				const store = useStore();
				store.dispatch(ActionTypes.PROGRESS_BAR, true);
				const api = '/api/export_sample_profilers';
				const formData = new FormData();
				return instance()(
					{
						method: 'post',
						url: api,
						data: formData,
					}
				).then(res => res.data)
					.catch((e) => ExceptionHandling.HandleErrors(e))
					.finally(() => {
						store.dispatch(ActionTypes.PROGRESS_BAR, false);
					})
			}
		
			uploadCSVFile(image) {
				////console.log("upload csv in js");
				//SHOW LOADING
				const store = useStore();
				store.dispatch(ActionTypes.PROGRESS_BAR, true);
				const api = '/api/import_sample_profilers';
				const formData = new FormData();
				formData.append('image', image);
		
				return instance()(
					{
						method: 'post',
						url: api,
						data: formData,
					}
				).then(res => res.data)
					.catch((e) => ExceptionHandling.HandleErrors(e))
					.finally(() => {
						store.dispatch(ActionTypes.PROGRESS_BAR, false);
					})
			}

			getSupplierCreditList(keyword, start) {
				//SHOW LOADING
				const store = useStore();
				store.dispatch(ActionTypes.PROGRESS_BAR, true);
				const api = '/api/supplier_credit_list';
				const formData = new FormData();
				formData.append('keyword', keyword);
				formData.append('start', start);
				return instance()(
					{
						method: 'post',
						url: api,
						data: formData,
					}
				).then(res => res.data)
					.catch((e) => ExceptionHandling.HandleErrors(e))
					.finally(() => {
						store.dispatch(ActionTypes.PROGRESS_BAR, false);
					})
			}

			settleSupplierCredit(keyword) {
				//SHOW LOADING
				const store = useStore();
				store.dispatch(ActionTypes.PROGRESS_BAR, true);
				const api = '/api/settle_supplier_credit';
				const formData = new FormData();
				formData.append('supplier_id', keyword);
				return instance()(
					{
						method: 'post',
						url: api,
						data: formData,
					}
				).then(res => res.data)
					.catch((e) => ExceptionHandling.HandleErrors(e))
					.finally(() => {
						store.dispatch(ActionTypes.PROGRESS_BAR, false);
					})
			}
}